import { Injectable } from '@angular/core';
import { IDvmFormatter } from '@3ddv/software-division-components';

@Injectable({
  providedIn: 'root'
})
export class DvmFormatterService implements IDvmFormatter {

  /**
   * Transforms a value according to DVM formatting rules
   * @param value - The value to transform
   * @param args - Additional arguments for transformation
   * @returns The transformed string
   */
  transform(value: string, ...args: unknown[]): string {
    // Basic formatting logic - you can customize this based on your needs
    if (!value) return '';

    // Convert to uppercase and replace dashes with spaces
    return value.replace(/-/g, ' ').toUpperCase();
  }
}
